export default "__VITE_ASSET__8737fff4__"